var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DEFAULT_OFFER_TYPE, PATH_SEGMENT_TRIPLE } from "../constants";
import { buildQueryString } from "./buildQueryString";
/**
 * Build the full URL to navigate to when the user submits the filter form.
 *
 * finance_type and monthly_price are encoded as path segments in the format:
 *   /(company|personal),(leasing|rent|loan),<monthly_price>/
 * All other filters are appended as query params.
 */
export function buildSubmitUrl(selectedState, pathname, search) {
    var _a, _b, _c, _d;
    const ft = String((_a = selectedState.finance_type) !== null && _a !== void 0 ? _a : "rent");
    const mp = String((_b = selectedState.monthly_price) !== null && _b !== void 0 ? _b : "max");
    const ot = String((_c = selectedState.offer_type) !== null && _c !== void 0 ? _c : DEFAULT_OFFER_TYPE);
    const base = (_d = (pathname + search).split("?")[0]) !== null && _d !== void 0 ? _d : "";
    let newBase;
    if (PATH_SEGMENT_TRIPLE.test(base)) {
        newBase = base.replace(PATH_SEGMENT_TRIPLE, `${ot},${ft},${mp}`);
    }
    else {
        const trimmed = base.replace(/\/$/, "");
        newBase = `${trimmed}/${ot},${ft},${mp}`;
    }
    const { finance_type, monthly_price, offer_type } = selectedState, queryFilters = __rest(selectedState, ["finance_type", "monthly_price", "offer_type"]);
    return `${newBase}${buildQueryString(queryFilters)}`;
}
